/* OCUDERM — «Ask about this product», el diálogo de la ficha.
 *
 * El marcado ya está en la página: lo pinta `ocu-product.liquid` dentro de un
 * `[data-ask]` con el atributo `hidden`. Aquí solo se abre, se cierra y se
 * cuida el teclado. Construirlo a mano —como hace el de los planes— no tenía
 * sentido: este lleva un formulario de Shopify dentro, y un formulario clonado
 * por Javascript no envía los campos ocultos que Shopify añade.
 *
 * LA RECARGA DE POR MEDIO
 *
 * El formulario es el de contacto de Shopify, que envía a la misma URL y
 * vuelve a pintar la ficha. O sea, que entre pulsar «Send question» y ver el
 * acuse hay una recarga. Para que no parezca que no pasó nada:
 *
 *   - antes de enviar se guarda el nombre y una bandera en `sessionStorage`;
 *   - al volver, si el Liquid pintó el acuse, se abre el diálogo solo y se
 *     escribe el nombre en «Thanks, …».
 *
 * Sin esto el paciente volvería a la ficha tal cual, sin saber si su pregunta
 * salió — que es la forma más segura de que la escriba otra vez.
 */

(function () {
  var caja = document.querySelector('[data-ask]');
  if (!caja) return;

  var LLAVE = 'ocu:ask';
  var EASE = 'cubic-bezier(.22,.75,.2,1)';
  var reduce = false;
  try {
    reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var tarjeta = caja.querySelector('.ocu-askbox__card');
  var velo = caja.querySelector('.ocu-askbox__scrim');
  var abierto = false;
  var focoAnterior = null;
  var scrollGuardado = 0;

  function alPulsarTecla(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      cerrar();
      return;
    }
    /* El foco se queda dentro: sin esto se tabula por detrás del diálogo y se
       escribe en el formulario de la página que está tapada. */
    if (e.key !== 'Tab' || !abierto) return;
    var foco = tarjeta.querySelectorAll(
      'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    );
    var vivos = [];
    for (var i = 0; i < foco.length; i++) {
      if (!foco[i].disabled && foco[i].offsetParent !== null) vivos.push(foco[i]);
    }
    if (!vivos.length) return;
    var primero = vivos[0];
    var ultimo = vivos[vivos.length - 1];
    if (e.shiftKey && document.activeElement === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primero.focus();
    }
  }

  function abrir() {
    if (abierto) return;
    abierto = true;
    focoAnterior = document.activeElement;
    caja.hidden = false;

    /* Se bloquea la página de detrás SIN perder el sitio: con `overflow:hidden`
       a secas, al cerrar el navegador salta arriba. */
    scrollGuardado = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollGuardado + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';

    if (!reduce && caja.animate) {
      velo.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 260,
        easing: EASE,
        fill: 'forwards',
      });
      tarjeta.animate(
        [
          { opacity: 0, transform: 'translateY(14px)' },
          { opacity: 1, transform: 'none' },
        ],
        { duration: 380, delay: 40, easing: EASE, fill: 'forwards' }
      );
    }

    /* El foco al primer campo, no al botón de cerrar: aquí se viene a
       escribir. En el acuse no hay campos y cae en «Close», que es lo
       correcto. */
    var primero = tarjeta.querySelector('input:not([type="hidden"]), textarea, button');
    if (primero) primero.focus();

    document.addEventListener('keydown', alPulsarTecla, true);
  }

  function cerrar() {
    if (!abierto) return;
    abierto = false;
    document.removeEventListener('keydown', alPulsarTecla, true);

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollGuardado);

    function esconder() {
      caja.hidden = true;
      if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
    }

    if (reduce || !caja.animate) {
      esconder();
      return;
    }
    var a = caja.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 220,
      easing: EASE,
      fill: 'forwards',
    });
    a.onfinish = function () {
      caja.style.opacity = '';
      esconder();
    };
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-ask-open]')) {
      e.preventDefault();
      abrir();
      return;
    }
    /* Solo el velo y los botones marcados cierran: un clic dentro de la
       tarjeta no debe cerrar, que es lo que pasa si se escucha en el
       contenedor sin mirar el objetivo. */
    if (t.closest('[data-ask-close]')) {
      e.preventDefault();
      cerrar();
    }
  });

  /* ── El relevo a través de la recarga ──────────────────────────────────── */

  var formulario = caja.querySelector('form');
  if (formulario) {
    formulario.addEventListener('submit', function () {
      var campo = caja.querySelector('[data-ask-field="name"]');
      try {
        sessionStorage.setItem(LLAVE, (campo && campo.value ? campo.value : '').trim());
      } catch (e) {}
    });
  }

  var acuse = caja.querySelector('.ocu-askbox__done');
  if (acuse) {
    var nombre = '';
    try {
      nombre = sessionStorage.getItem(LLAVE) || '';
      sessionStorage.removeItem(LLAVE);
    } catch (e) {}
    var hueco = acuse.querySelector('[data-ask-name]');
    if (hueco && nombre) hueco.textContent = ', ' + nombre;
    abrir();
  }
})();
